export default function ArticleBody({ body }: { body: string }) {
  const paragraphs = body
    .split(/\n{2,}|\r\n\r\n/)
    .map((p) => p.trim())
    .filter(Boolean);

  return (
    <div className="space-y-5">
      {paragraphs.map((p, i) => (
        <p key={i} className="text-foreground-800 text-base md:text-lg leading-relaxed">{p}</p>
      ))}
    </div>
  );
}